/*!
 * Bookeaz Hyperlocal Location Popup
 * Blinkit-style modal + pill that writes to Webkul Hyperlocal's
 * canonical localStorage keys so MVM Hyperlocal continues to filter.
 *
 * Self-sufficient: uses Google Places Autocomplete on its own input,
 * does its own reverse-geocoding for "Use current location". Does NOT
 * rely on Webkul's widget event handlers (which break when DOM-moved).
 *
 * Webkul keys we write:
 *   - wk_customer_location  JSON: {place, lat, lng}
 *   - wk_hyperlocal_zipcode (string, optional)
 * We also clear Webkul's cached seller arrays so it re-fetches on reload.
 */
(function () {
  'use strict';

  // ---------- config ----------
  var DEFAULTS = {
    autoOpen: true,
    autoOpenUntilSet: true,
    blocking: false,
    reloadOnChange: true,
    listingPageUrl: '', // leave empty to auto-detect window.hyobj_allproducts_url, else '/pages/allproducts'
    popupTitle: 'Change Location',
    inputPlaceholder: 'Search delivery location',
    searchButtonLabel: 'Search',
    useMyLocationLabel: 'Detect my location',
    detectingLabel: 'Detecting your location…',
    geocodingLabel: 'Looking up address…',
    savedAddressesLabel: 'Recent addresses',
    currentLocationLabel: 'Deliver to',
    pillEmptyStatus: 'Welcome',
    pillEmptyAddress: 'Select Location',
    changeLabel: 'Change'
  };
  var config = Object.assign({}, DEFAULTS, (window.BookeazLocationConfig || {}));

  // ---------- constants ----------
  var WK_LOC_KEY = 'wk_customer_location';
  var WK_ZIP_KEY = 'wk_hyperlocal_zipcode';
  var WK_KEYS_TO_CLEAR = [
    'wk_seller_details_for_hyp',
    'wk_seller_ids',
    'wk_seller_ids_str_hyp',
    'wk_seller_stores',
    'wk_seller_slottime',
    'wk_encrypted_seller_ids',
    'wk_product_pagination_detail'
  ];
  var RECENT_KEY = 'bookeaz_recent_locations';
  var DISMISSED_KEY = 'bookeaz_location_dismissed';
  var POLL_MS = 400;

  // ---------- helpers ----------
  function readWkLocation() {
    try {
      var raw = localStorage.getItem(WK_LOC_KEY);
      if (!raw) return null;
      var p = JSON.parse(raw);
      if (!p || (!p.place && !p.lat && !p.lng)) return null;
      return p;
    } catch (e) { return null; }
  }
  function writeWkLocation(loc) {
    if (!loc || !loc.place) return;
    var payload = { place: loc.place, lat: loc.lat, lng: loc.lng };
    try { localStorage.setItem(WK_LOC_KEY, JSON.stringify(payload)); } catch (e) {}
    // clear caches so Webkul re-fetches sellers on next page load
    WK_KEYS_TO_CLEAR.forEach(function (k) {
      try { localStorage.removeItem(k); } catch (e) {}
    });
    // optional zipcode
    if (loc.zipcode) {
      try { localStorage.setItem(WK_ZIP_KEY, String(loc.zipcode)); } catch (e) {}
    }
  }
  function readRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; }
  }
  function writeRecent(arr) {
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(arr.slice(0, 5))); } catch (e) {}
  }
  function addRecent(loc) {
    if (!loc || !loc.place) return;
    var list = readRecent().filter(function (x) { return x.place !== loc.place; });
    list.unshift({ place: loc.place, lat: loc.lat, lng: loc.lng, zipcode: loc.zipcode || '', ts: Date.now() });
    writeRecent(list);
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  // ---------- DOM refs ----------
  var modal, slot, statusEl, savedWrap, savedList;
  var pills = [];
  var ownInput = null, ownSearchBtn = null, ownDetectBtn = null;
  var ownAutocomplete = null;
  var googleReadyPolling = false;

  function refreshDomRefs() {
    modal     = $('#bookeaz-location-modal');
    slot      = $('[data-bookeaz-webkul-slot]');
    statusEl  = $('[data-bookeaz-status]');
    savedWrap = $('[data-bookeaz-saved]');
    savedList = $('[data-bookeaz-saved-list]');
    pills     = $all('[data-bookeaz-open]');
  }
  function setStatus(msg) {
    if (!statusEl) return;
    if (msg) { statusEl.textContent = msg; statusEl.hidden = false; }
    else     { statusEl.textContent = '';  statusEl.hidden = true;  }
  }

  // ---------- pill ----------
  function updatePill() {
    var loc = readWkLocation();
    pills.forEach(function (pill) {
      var statusNode  = pill.querySelector('[data-bookeaz-pill-status]');
      var addressNode = pill.querySelector('[data-bookeaz-pill-address]');
      if (loc && loc.place) {
        if (statusNode)  statusNode.textContent  = config.currentLocationLabel;
        if (addressNode) addressNode.textContent = loc.place;
        pill.setAttribute('data-bookeaz-has-location', 'true');
      } else {
        if (statusNode)  statusNode.textContent  = config.pillEmptyStatus;
        if (addressNode) addressNode.textContent = config.pillEmptyAddress;
        pill.setAttribute('data-bookeaz-has-location', 'false');
      }
    });
  }

  // ---------- recent list ----------
  function renderRecent() {
    if (!savedWrap || !savedList) return;
    var items = readRecent();
    if (!items.length) { savedWrap.hidden = true; return; }
    savedWrap.hidden = false;
    savedList.innerHTML = '';
    items.forEach(function (it, i) {
      var li = document.createElement('li');
      li.className = 'bookeaz-loc-modal__saved-item';
      li.innerHTML =
        '<button type="button" class="bookeaz-loc-modal__saved-btn" data-bookeaz-pick="' + i + '">' +
          '<span class="bookeaz-loc-modal__saved-pin" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" width="14" height="14" focusable="false"><path fill="currentColor" d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"/></svg>' +
          '</span>' +
          '<span class="bookeaz-loc-modal__saved-text">' + escapeHtml(it.place) + '</span>' +
        '</button>';
      savedList.appendChild(li);
    });
  }

  // ---------- modal ----------
  function openModal() {
    if (!modal) return;
    renderOwnWidget();
    renderRecent();
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('bookeaz-loc-locked');
    setTimeout(function () {
      if (ownInput) try { ownInput.focus(); } catch (e) {}
    }, 50);
  }
  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('bookeaz-loc-locked');
    try { sessionStorage.setItem(DISMISSED_KEY, '1'); } catch (e) {}
  }

  // ---------- Webkul's original on-page widget: hide it so we don't show two copies ----------
  function hideOriginalWebkulWidget() {
    // Webkul's homepage widget is the form.wk_search_fld inside .wk_hyperlocal_banner.
    // Also hide the wk_cstm_loc summary block that wraps a duplicate set of controls.
    try {
      $all('form.wk_search_fld').forEach(function (f) {
        if (f.getAttribute('data-bookeaz-wk-hidden') === '1') return;
        f.setAttribute('data-bookeaz-wk-hidden', '1');
        f.style.display = 'none';
        var banner = f.closest('.wk_hyperlocal_banner');
        if (banner) banner.style.display = 'none';
      });
      $all('.wk_cstm_loc').forEach(function (b) {
        if (b.getAttribute('data-bookeaz-wk-hidden') === '1') return;
        b.setAttribute('data-bookeaz-wk-hidden', '1');
        b.style.display = 'none';
      });
    } catch (e) {}
  }

  // ---------- self-sufficient widget rendered in the modal slot ----------
  function renderOwnWidget() {
    if (!slot) return;
    if (slot.querySelector('[data-bookeaz-own-input]')) {
      // already rendered, just refresh state
      return;
    }
    slot.innerHTML =
      '<div class="bookeaz-loc-modal__own">' +
        '<div class="bookeaz-loc-modal__detect-row">' +
          '<button type="button" class="bookeaz-loc-modal__detect-btn" data-bookeaz-detect>' +
            '<span class="bookeaz-loc-modal__detect-icon" aria-hidden="true">' +
              '<svg viewBox="0 0 24 24" width="20" height="20" focusable="false"><path fill="currentColor" d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm8.94 3A8.99 8.99 0 0 0 13 3.06V1h-2v2.06A8.99 8.99 0 0 0 3.06 11H1v2h2.06A8.99 8.99 0 0 0 11 20.94V23h2v-2.06A8.99 8.99 0 0 0 20.94 13H23v-2h-2.06zM12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14z"/></svg>' +
            '</span>' +
            '<span class="bookeaz-loc-modal__detect-text">' + escapeHtml(config.useMyLocationLabel) + '</span>' +
          '</button>' +
        '</div>' +
        '<div class="bookeaz-loc-modal__or"><span>OR</span></div>' +
        '<div class="bookeaz-loc-modal__search-row">' +
          '<span class="bookeaz-loc-modal__search-icon" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" width="18" height="18" focusable="false"><path fill="currentColor" d="M15.5 14h-.79l-.28-.27a6.471 6.471 0 0 0 1.48-5.34C15.43 6.04 13.43 3.92 10.92 3.45a6.503 6.503 0 0 0-7.47 7.47c.47 2.51 2.59 4.51 5.94 4.99 1.85.28 3.82-.25 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0l.01-.01c.41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>' +
          '</span>' +
          '<input type="text" class="bookeaz-loc-modal__search-input" data-bookeaz-own-input ' +
            'placeholder="' + escapeHtml(config.inputPlaceholder) + '" ' +
            'autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false">' +
          '<button type="button" class="bookeaz-loc-modal__search-btn" data-bookeaz-own-search disabled>' +
            escapeHtml(config.searchButtonLabel) +
          '</button>' +
        '</div>' +
      '</div>';
    ownInput     = slot.querySelector('[data-bookeaz-own-input]');
    ownSearchBtn = slot.querySelector('[data-bookeaz-own-search]');
    ownDetectBtn = slot.querySelector('[data-bookeaz-detect]');
    if (ownInput) {
      ownInput.addEventListener('input', function () {
        if (ownSearchBtn) ownSearchBtn.disabled = !this.value.trim();
      });
      ownInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleSearchSubmit();
        }
      });
    }
    if (ownSearchBtn) {
      ownSearchBtn.addEventListener('click', function (e) {
        e.preventDefault();
        handleSearchSubmit();
      });
    }
    if (ownDetectBtn) {
      ownDetectBtn.addEventListener('click', function (e) {
        e.preventDefault();
        handleDetectLocation();
      });
    }
    waitForGoogleAndAttachAutocomplete();
  }

  // ---------- Google Places autocomplete on our own input ----------
  function googleReady() {
    return !!(window.google && window.google.maps && window.google.maps.places && window.google.maps.places.Autocomplete);
  }
  function waitForGoogleAndAttachAutocomplete() {
    if (!ownInput) return;
    if (ownAutocomplete) return;
    if (googleReady()) { attachOwnAutocomplete(); return; }
    if (googleReadyPolling) return;
    googleReadyPolling = true;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (googleReady() && ownInput) {
        clearInterval(iv);
        googleReadyPolling = false;
        attachOwnAutocomplete();
      } else if (tries > 50) { // 25s
        clearInterval(iv);
        googleReadyPolling = false;
      }
    }, 500);
  }
  function attachOwnAutocomplete() {
    if (!ownInput || ownAutocomplete) return;
    try {
      ownAutocomplete = new google.maps.places.Autocomplete(ownInput);
      ownAutocomplete.setFields(['place_id', 'geometry', 'name', 'formatted_address', 'address_components']);
      ownAutocomplete.addListener('place_changed', function () {
        var place = ownAutocomplete.getPlace();
        if (!place || !place.geometry || !place.geometry.location) {
          // no geometry -> let user click Search to geocode by raw text
          return;
        }
        var addr = place.formatted_address || place.name || (ownInput && ownInput.value) || '';
        var lat = place.geometry.location.lat();
        var lng = place.geometry.location.lng();
        var zip = extractZipFromAddressComponents(place.address_components);
        commitLocation({ place: addr, lat: lat, lng: lng, zipcode: zip });
      });
    } catch (e) {
      // ignore — fallback to manual search
    }
  }
  function extractZipFromAddressComponents(comps) {
    if (!comps || !comps.length) return null;
    for (var i = 0; i < comps.length; i++) {
      var c = comps[i];
      if (c && c.types && c.types.indexOf('postal_code') !== -1) return c.short_name || c.long_name || null;
    }
    return null;
  }

  // ---------- Search button: geocode whatever's in the input ----------
  function handleSearchSubmit() {
    if (!ownInput) return;
    var q = (ownInput.value || '').trim();
    if (!q) return;
    if (!googleReady()) {
      setStatus('Map service still loading, please wait a moment and try again.');
      return;
    }
    setStatus(config.geocodingLabel);
    if (ownSearchBtn) ownSearchBtn.disabled = true;
    try {
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: q }, function (results, status) {
        if (ownSearchBtn) ownSearchBtn.disabled = !ownInput.value.trim();
        if (status === 'OK' && results && results.length > 0) {
          var r = results[0];
          var addr = r.formatted_address || q;
          var lat = r.geometry.location.lat();
          var lng = r.geometry.location.lng();
          var zip = extractZipFromAddressComponents(r.address_components);
          commitLocation({ place: addr, lat: lat, lng: lng, zipcode: zip });
        } else {
          setStatus('Could not find that address. Try a more specific location.');
        }
      });
    } catch (e) {
      setStatus('Map service error. Please refresh and try again.');
      if (ownSearchBtn) ownSearchBtn.disabled = !ownInput.value.trim();
    }
  }

  // ---------- Detect: browser geolocation -> reverse-geocode ----------
  function handleDetectLocation() {
    if (!navigator.geolocation) {
      setStatus('Geolocation is not supported in this browser.');
      return;
    }
    if (ownDetectBtn) ownDetectBtn.disabled = true;
    setStatus(config.detectingLabel);
    navigator.geolocation.getCurrentPosition(function (pos) {
      var lat = pos.coords.latitude;
      var lng = pos.coords.longitude;
      if (!googleReady()) {
        // commit lat/lng without an address as a last resort
        commitLocation({ place: lat.toFixed(5) + ', ' + lng.toFixed(5), lat: lat, lng: lng });
        if (ownDetectBtn) ownDetectBtn.disabled = false;
        return;
      }
      try {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ location: { lat: lat, lng: lng } }, function (results, status) {
  if (ownDetectBtn) ownDetectBtn.disabled = false;
  if (status === 'OK' && results && results.length > 0) {
    // results[0] is often a very precise premise/plus-code result with
    // no city/state/zip — prefer one that actually has a postal code.
    var best = results.find(function (r) {
      return r.address_components.some(function (c) {
        return c.types.indexOf('postal_code') !== -1;
      });
    }) || results.find(function (r) {
      return r.types.indexOf('street_address') !== -1;
    }) || results[0];

    var addr = best.formatted_address || (lat.toFixed(5) + ', ' + lng.toFixed(5));
    var zip = extractZipFromAddressComponents(best.address_components);
    commitLocation({ place: addr, lat: lat, lng: lng, zipcode: zip });
  } else {
    commitLocation({ place: lat.toFixed(5) + ', ' + lng.toFixed(5), lat: lat, lng: lng });
  }
});
      } catch (e) {
        commitLocation({ place: lat.toFixed(5) + ', ' + lng.toFixed(5), lat: lat, lng: lng });
        if (ownDetectBtn) ownDetectBtn.disabled = false;
      }
    }, function (err) {
      if (ownDetectBtn) ownDetectBtn.disabled = false;
      var msg = 'Could not detect your location.';
      if (err && err.code === 1) msg = 'Location permission denied. Type your address above instead.';
      else if (err && err.code === 3) msg = 'Location request timed out. Try again.';
      setStatus(msg);
    }, { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 });
  }

  // ---------- commit ----------
  function commitLocation(loc) {
  if (!loc || !loc.place) return;
  setStatus('Saving…');
  writeWkLocation(loc);
  addRecent(loc);
  try { sessionStorage.removeItem(DISMISSED_KEY); } catch (e) {}
  updatePill();
  try { document.dispatchEvent(new CustomEvent('bookeaz:location:set', { detail: loc })); } catch (e) {}
  closeModal();
  if (config.reloadOnChange) {
  setTimeout(function () {
    var listingUrl = getListingUrl();
    var samePage = window.location.pathname.replace(/\/$/, '') === listingUrl.replace(/\/$/, '');
    if (samePage) {
      window.location.reload();
    } else {
      window.location.href = listingUrl;
    }
  }, 200);
}
}
  // ---------- location-change watcher (for external writes / other tabs) ----------
  var lastLocSerialized = JSON.stringify(readWkLocation());
  function pollWkLocation() {
    var cur = JSON.stringify(readWkLocation());
    if (cur !== lastLocSerialized) {
      lastLocSerialized = cur;
      updatePill();
    }
  }
  setInterval(pollWkLocation, POLL_MS);
  window.addEventListener('storage', function (e) {
    if (e.key === WK_LOC_KEY) pollWkLocation();
  });

  // ---------- clear ----------
  function clearLocation() {
    try { localStorage.removeItem(WK_LOC_KEY); } catch (e) {}
    try { localStorage.removeItem(WK_ZIP_KEY); } catch (e) {}
    WK_KEYS_TO_CLEAR.forEach(function (k) {
      try { localStorage.removeItem(k); } catch (e) {}
    });
    updatePill();
    try { document.dispatchEvent(new CustomEvent('bookeaz:location:cleared')); } catch (e) {}
    if (config.reloadOnChange) setTimeout(function () { window.location.reload(); }, 200);
  }

  // ---------- bindings ----------
  function bind() {
    refreshDomRefs();
    hideOriginalWebkulWidget();
    updatePill();
    renderRecent();

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      // Ignore clicks inside Google Places autocomplete dropdown so it can
      // handle suggestion selection without us swallowing the click.
      if (t.closest('.pac-container, .pac-item')) return;

      var openTrig = t.closest('[data-bookeaz-open]');
      if (openTrig) { e.preventDefault(); openModal(); return; }

      var closeTrig = t.closest('[data-bookeaz-close]');
      if (closeTrig) { e.preventDefault(); closeModal(); return; }

      var pickTrig = t.closest('[data-bookeaz-pick]');
      if (pickTrig) {
        e.preventDefault();
        var idx = parseInt(pickTrig.getAttribute('data-bookeaz-pick'), 10);
        var rec = readRecent()[idx];
        if (rec && rec.lat && rec.lng) {
          commitLocation({ place: rec.place, lat: rec.lat, lng: rec.lng, zipcode: rec.zipcode || '' });
        }
        return;
      }

      var clearTrig = t.closest('[data-bookeaz-clear-location]');
      if (clearTrig) { e.preventDefault(); clearLocation(); return; }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden && !config.blocking) closeModal();
    });

    // re-hide Webkul's widget if it gets re-injected after navigation
    var hideIv = setInterval(hideOriginalWebkulWidget, 1000);
    setTimeout(function () { clearInterval(hideIv); }, 15000);

    // auto-open
    var existing = readWkLocation();
    if (!existing) {
      if (config.autoOpen) {
        var dismissed = false;
        try { dismissed = !!sessionStorage.getItem(DISMISSED_KEY); } catch (e) {}
        if (config.autoOpenUntilSet || config.blocking || !dismissed) {
          setTimeout(openModal, 600);
        }
      }
    }
  }

  // new helper
function getListingUrl() {
  if (config.listingPageUrl) return config.listingPageUrl;
  if (typeof window.hyobj_allproducts_url !== 'undefined' && window.hyobj_allproducts_url) {
    return window.hyobj_allproducts_url;
  }
  return '/pages/allproducts';
}

  // ---------- public api ----------
  window.BookeazLocation = window.BookeazLocation || {};
  window.BookeazLocation.openPopup = openModal;
  window.BookeazLocation.closePopup = closeModal;
  window.BookeazLocation.getLocation = readWkLocation;
  window.BookeazLocation.clearLocation = clearLocation;
  window.BookeazLocation.on = function (evt, fn) {
    document.addEventListener('bookeaz:location:' + evt, function (e) { fn(e.detail); });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
